import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import React from 'react';
import { connect } from 'react-redux';
import { INode, ISystem } from '../../helpers/interfaces';
import RadioCommunicationIcon from "./RadioCommunicationIcon";
import SensorIcon from "./SensorIcon";
import TemperatureIcon from "./TemperatureIcon";
import { batteryColorMap } from '../../helpers/GlobalVariables';
import {PowerSupplyIcon} from "./PowerSupplyIcon";
import {SignalStrengthIcon} from "./SignalStrengthIcon";

interface INodeStatusIconsProps {
    node: INode;
    showRadioCommunicationIcon: boolean;
    showSensorIcon: boolean;
    showTemperatureIcon: boolean;
    showPowerIcon: boolean;
    showSignalStrengthIcon: boolean;
}
const COLOR_GREEN = '#31b800';
const COLOR_YELLOW = '#ffe11c';
const COLOR_RED = '#ff0000';
class NodeStatusIcons extends React.Component<INodeStatusIconsProps> {

    getRadioCommunicationStatusColor(node: INode) {
        if (node.SystemVersion === 'W2') {
            if (node.W2ConnectionStatus == 0) {
                return COLOR_GREEN;
            } else if (node.W2ConnectionStatus == 1 || node.W2ConnectionStatus == 2) {
                return COLOR_YELLOW;
            } else if (node.W2ConnectionStatus == 3) {
                return COLOR_RED;
            } else {
                return COLOR_GREEN;
            }
        } else {
            const currentDate = Date.now();
            const parsedDate = Date.parse(node.LatestPacketTimestamp);
            const showWarningTime1 = 1000 * 60 * 60 * 6;
            const showWarningTime2 = 1000 * 60 * 60 * 24;
            if ((currentDate - parsedDate) < showWarningTime1) {
                return COLOR_GREEN;
            } else if ((currentDate - parsedDate) >= showWarningTime1 && (currentDate - parsedDate) < showWarningTime2) {
                return COLOR_YELLOW;
            } else {
                return COLOR_RED;
            }
        }
    }

    getSensorStatusColor(node: INode) {
        const sensorType = node.MainSensorType;

        if (node.outOfRange) {
            return COLOR_YELLOW;
        }

        if (sensorType == 'none' || this.getRadioCommunicationStatusColor(node) == COLOR_RED) {
            return COLOR_GREEN;
        }
        if (sensorType == 'inclinometer' && node.InclinometerStatus) {
            return COLOR_RED;
        } else if (sensorType == 'laser' && node.RangeFinderStatus && node.RangeFinderStatus !== 3) {
            return COLOR_RED;
        }
        return COLOR_GREEN;
    }

    getTemperatureStatusColor(node: INode) {
        if (node.TemperatureOK || node.TemperatureOK == null) {
            return COLOR_GREEN;
        }
        return COLOR_RED;
    }


    render() {
        const {
            node,
            showRadioCommunicationIcon,
            showSensorIcon,
            showTemperatureIcon,
            showPowerIcon,
            showSignalStrengthIcon
        } = this.props;
        const iconsRowStyle = {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            flexDirection: 'row'
        };

        return (
            <GridContainer style={{flexBasis: "fit-content", maxWidth: "100%"}}>
                <GridItem xs={12} style={iconsRowStyle} data-testid='nodeStatusIcons'>
                    <RadioCommunicationIcon
                        show={showRadioCommunicationIcon}
                        color={this.getRadioCommunicationStatusColor(node)}
                    />
                    <SensorIcon
                        show={showSensorIcon}
                        color={this.getSensorStatusColor(node)}
                    />
                    <TemperatureIcon
                        show={showTemperatureIcon}
                        color={this.getTemperatureStatusColor(node)}
                    />
                    <PowerSupplyIcon
                        show={showPowerIcon}
                        supplyState={node.SupplyState}
                    />
                    <SignalStrengthIcon
                        show={showSignalStrengthIcon}
                        color={this.getTemperatureStatusColor(node)}
                        signalStrength={node.SignalStrength}
                    />
                </GridItem>
            </GridContainer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        currentNodeId: state.dashboard.currentNodeId,
        nodes: state.dashboard.nodes,
        systems: state.dashboard.systems,
    };
};

export default connect(mapStateToProps, null)(NodeStatusIcons);
